import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/property-banner.png'


const _withScopeId = n => (_pushScopeId("data-v-02a02512"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "project__property__flow"
}
const _hoisted_2 = {
  key: 0,
  class: "project__property__list__header"
}
const _hoisted_3 = { class: "project__property__list__header__left" }
const _hoisted_4 = { class: "project__property__content" }
const _hoisted_5 = { class: "property_badge" }
const _hoisted_6 = {
  key: 0,
  class: "notification"
}
const _hoisted_7 = {
  key: 1,
  class: "property_badge_text"
}
const _hoisted_8 = { class: "property_text md:!tw-mt-[2px]" }
const _hoisted_9 = { class: "md:!tw-text-[18px]" }
const _hoisted_10 = { class: "card__content" }
const _hoisted_11 = {
  key: 0,
  class: "card__content__text"
}
const _hoisted_12 = {
  key: 0,
  class: "property-select"
}
const _hoisted_13 = { class: "property-listing-container" }
const _hoisted_14 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_15 = { class: "topproperty_listing" }
const _hoisted_16 = { class: "toplist_details" }
const _hoisted_17 = { class: "topright_details" }
const _hoisted_18 = { class: "two_icons" }
const _hoisted_19 = { class: "left__block" }
const _hoisted_20 = { class: "courses__card__list" }
const _hoisted_21 = { class: "courses__card__img" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "courses__card__prefix" }
const _hoisted_24 = { class: "left__prefix" }
const _hoisted_25 = { class: "right__prefix" }
const _hoisted_26 = { class: "courses__card__text" }
const _hoisted_27 = { class: "courses__card__title" }
const _hoisted_28 = {
  key: 0,
  class: "map__container tw-rounded-xl tw-overflow-hidden"
}
const _hoisted_29 = { class: "load__wrapper" }
const _hoisted_30 = {
  key: 1,
  class: "empty__content"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty__banner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "empty__banner__img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "empty__banner__content" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "You haven’t added any properties yet."),
    /*#__PURE__*/_createElementVNode("p", null, "Add a property(s) to get started.")
  ])
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "property-select-type"
}
const _hoisted_34 = { class: "project-steps-content" }
const _hoisted_35 = { class: "project-service-list" }
const _hoisted_36 = { class: "project-service-item__logo" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "project-service-item__text" }
const _hoisted_39 = {
  key: 0,
  class: "project__button md:!tw-mt-0"
}
const _hoisted_40 = {
  key: 1,
  class: "footer__btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_LeafletMap = _resolveComponent("LeafletMap")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_PropertyMapModal = _resolveComponent("PropertyMapModal")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_ProjectTypeComponent = _resolveComponent("ProjectTypeComponent")!
  const _component_AddHistoricalProject = _resolveComponent("AddHistoricalProject")!
  const _component_PropertyOwnerSubscriptionModal = _resolveComponent("PropertyOwnerSubscriptionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isShowHistoricalProjectFlow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($setup.currentSelectedTab?.id <= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    "aria-label": "Refresh",
                    class: "button-transparent back_btn",
                    "prepend-icon": "mdi-chevron-left",
                    onClick: $setup.onClickBackButton
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.backButtonLabelList[$setup.currentSelectedTab?.id - 1]?.label || "back"), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!$setup.isShowProjectType)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([
        $props.className || $setup.PropertyListLengthZero
          ? 'project__property__list-empty'
          : ''
      , "project__property__list"])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (!$setup.PropertyListLengthZero)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.currentSelectedTab.id), 1))
                      : _createCommentVNode("", true),
                    (!$setup.PropertyListLengthZero)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.currentSelectedTab.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h4", _hoisted_9, _toDisplayString($setup.PropertyListLengthZero ? "" : $setup.currentSelectedTab.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    ($setup.currentSelectedTab.id == 1 && !$setup.isFetchingPropertiesLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (!$setup.PropertyListLengthZero)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  ($setup.isFetchingPropertiesLoading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createVNode(_component_CommonLoader, { loading: $setup.isFetchingPropertiesLoading }, null, 8, ["loading"])
                                      ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_15, [
                                          _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", null, _toDisplayString($setup.paginationData?.totalPropertiesCount ||
                          $setup.propertiesList.length) + " Properties ", 1),
                                            _createTextVNode(" | "),
                                            _createElementVNode("div", null, _toDisplayString($setup.selectedPropertyIds.length) + " Selected", 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["right_btn", { active: !$setup.isMapView }])
                                              }, [
                                                _createVNode(_component_v_btn, {
                                                  "prepend-icon": "mdi-view-grid",
                                                  variant: "text",
                                                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isMapView = false))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Tile ")
                                                  ]),
                                                  _: 1
                                                })
                                              ], 2),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["right_btn", { active: $setup.isMapView }])
                                              }, [
                                                _createVNode(_component_v_btn, {
                                                  "prepend-icon": "mdi-map",
                                                  variant: "text",
                                                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isMapView = !$setup.isMapView))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Map ")
                                                  ]),
                                                  _: 1
                                                })
                                              ], 2)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["property__location", { show: $setup.isMapView }])
                                        }, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.propertiesList, (property, index) => {
                                                return (_openBlock(), _createBlock(_component_v_card, {
                                                  class: _normalizeClass(["courses__card", { 'selected-card': $setup.isSelected(property?.id) }]),
                                                  onClick: ($event: any) => ($setup.toggleSelection(property?.id)),
                                                  key: index
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_21, [
                                                      (!property?.propertyImage)
                                                        ? (_openBlock(), _createBlock(_component_LeafletMap, {
                                                            key: 0,
                                                            data: [],
                                                            isDraggable: false,
                                                            showControls: false,
                                                            defaultViewZoom: 17,
                                                            latlang: $setup.getLatLng(property?.addressData)
                                                          }, null, 8, ["latlang"]))
                                                        : (_openBlock(), _createElementBlock("img", {
                                                            key: 1,
                                                            class: "tw-w-full tw-h-full",
                                                            src: property?.publicUrl
                                                          }, null, 8, _hoisted_22))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_23, [
                                                      _createElementVNode("div", _hoisted_24, [
                                                        _createVNode(_component_v_icon, { icon: "mdi-account" }),
                                                        _createElementVNode("p", null, _toDisplayString($setup.getPropertyType(property)), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_25, [
                                                        _createVNode(_component_v_icon, { icon: "mdi-map-marker" }),
                                                        _createElementVNode("p", null, _toDisplayString(property?.postcode), 1)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_26, [
                                                      _createElementVNode("h5", _hoisted_27, _toDisplayString(property?.address), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class", "onClick"]))
                                              }), 128))
                                            ])
                                          ]),
                                          ($setup.addresses && $setup.addresses.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                _createVNode(_component_PropertyMapModal, { properties: $setup.parsedPropertyList }, null, 8, ["properties"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 2),
                                        _createElementVNode("div", _hoisted_29, [
                                          ($setup.isPaginationAvailable)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                onClick: $setup.onLoadMore,
                                                variant: "text",
                                                "aria-label": "Refresh",
                                                class: "back_btn yellow-text",
                                                "append-icon": "mdi-chevron-right",
                                                disabled: $setup.isFetchingPropertiesLoading,
                                                loading: $setup.isFetchingPropertiesLoading
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Load " + _toDisplayString($setup.paginationData.totalPropertiesCount -
                        $setup.paginationData.currentPage * $setup.paginationData.limit) + " More Properties", 1)
                                                ]),
                                                _: 1
                                              }, 8, ["onClick", "disabled", "loading"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 64))
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Loader, { show: $setup.isFetchingPropertiesLoading }, null, 8, ["show"]),
                    ($setup.currentSelectedTab.id == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectTypeList, (item) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  class: _normalizeClass(["project-service-item", { selected: item.selected }]),
                                  key: item.id,
                                  onClick: ($event: any) => ($setup.toggleSelectionType(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_36, [
                                      (item.iconName)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "list_content_btn"
                                          }, {
                                            default: _withCtx(() => [
                                              (item.iconName)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: 
                          require('@/assets/icons/' + item.iconName + '.svg')
                        ,
                                                    alt: "icon"
                                                  }, null, 8, _hoisted_37))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("h5", null, _toDisplayString(item.name), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.subTitle), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([$props.className + '_footer', "footer md:!tw-gap-4 md:!tw-mt-0 md:!tw-pb-8"])
                }, [
                  (!($setup.currentSelectedTab.id == 1 && !$setup.isFetchingPropertiesLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_component_v_btn, {
                          "aria-label": "Refresh",
                          class: "button button-orange w-100",
                          onClick: $setup.onClickToggleContinue,
                          disabled: !$setup.isProjectTypeSelected
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("continue")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.currentSelectedTab.id == 1 && !$setup.isFetchingPropertiesLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        ($props.workflowType === $setup.PropertyWorkflowTypeEnum.PROPERTY)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              "aria-label": "Refresh",
                              class: "button button-purple-border",
                              onClick: $setup.onClickAddProperty
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("ADD NEW PROPERTY")
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_btn, {
                          "aria-label": "Refresh",
                          class: "button button-orange",
                          onClick: $setup.submitSelectedCards,
                          disabled: $setup.isSubmitButtonDisabled
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("continue")
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  (
          !$setup.PropertyListLengthZero &&
          [
           $setup.PropertyWorkflowTypeEnum.PROPERTY,
           $setup.PropertyWorkflowTypeEnum.RAISE_CLIENT,
         ].includes($props.workflowType as PropertyWorkflowTypeEnum) 
        )
                    ? (_openBlock(), _createBlock(_component_v_stepper, {
                        key: 2,
                        class: "onboard-stepper md:!tw-pb-4",
                        modelValue: $setup.currentSelectedTab.id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.currentSelectedTab.id) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getStepperList, (step) => {
                                return (_openBlock(), _createBlock(_component_v_stepper_item, {
                                  class: _normalizeClass(["onboard-stepper__item", { done: $setup.currentSelectedTab.id > step.id }]),
                                  key: step.id,
                                  title: step.tab,
                                  value: step.id
                                }, null, 8, ["class", "title", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ], 2)
              ], 2))
            : (_openBlock(), _createBlock(_component_ProjectTypeComponent, {
                key: 2,
                onOnClickBackButtonType: $setup.onClickBackButtonType,
                onOnClickeditProjectPropertyList: $setup.onClickeditProjectPropertyList,
                onOnClickSaveLater: $setup.onClickSaveLater,
                projectRefData: $setup.projectRefData,
                isEditMode: $setup.isEditMode,
                workflowType: $props.workflowType,
                selectedClient: $props.selectedClient
              }, null, 8, ["onOnClickBackButtonType", "onOnClickeditProjectPropertyList", "onOnClickSaveLater", "projectRefData", "isEditMode", "workflowType", "selectedClient"]))
        ]))
      : _createCommentVNode("", true),
    ($setup.isShowHistoricalProjectFlow)
      ? (_openBlock(), _createBlock(_component_AddHistoricalProject, {
          key: 1,
          onOnBack: $setup.onHistoricalProjectBack,
          onOnHistoricProjectSaved: $setup.onHistoricalProjectSave,
          property: $setup.userSelectedProperties[0],
          isHistoricalDraftProjectFlow: $props.isHistoricalDraftProjectFlow
        }, null, 8, ["onOnBack", "onOnHistoricProjectSaved", "property", "isHistoricalDraftProjectFlow"]))
      : _createCommentVNode("", true),
    ($setup.isShowUpgradePremiumModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerSubscriptionModal, {
          key: 2,
          onCloseSubscriptionModal: $setup.closeUpgradePremiumModal,
          onCloseSelectWorkstationTypeModal: $setup.closeUpgradePremiumModal
        }, null, 8, ["onCloseSubscriptionModal", "onCloseSelectWorkstationTypeModal"]))
      : _createCommentVNode("", true)
  ], 64))
}